export default {
  GET_MESSAGE_DATA_REQUESTED: 'GET_MESSAGE_DATA_REQUESTED',
  GET_MESSAGE_DATA_READ_REQUESTED: 'GET_MESSAGE_DATA_READ_REQUESTED',
  GET_MESSAGE_DATA_READ_SUCCEEDED: 'GET_MESSAGE_DATA_READ_SUCCEEDED',
  GET_MESSAGE_DATA_READ_FAILED: 'GET_MESSAGE_DATA_READ_FAILED',
  GET_MESSAGE_DATA_SUCCEEDED: 'GET_MESSAGE_DATA_SUCCEEDED',
  GET_MESSAGE_DATA_FAILED: 'GET_MESSAGE_DATA_FAILED',
};
